import { Box, Button, Grid2 } from "@mui/material";
import { useMaterialReactTable } from "material-react-table";
import { _ROUTES } from "../../utils/_routes_constants";
import { _ACTIONS, _COLORS, _HTTP, _SWAL_ICONS } from "../../utils/constants";
import { MuiTableComponent } from "../helpers/MuiTableComponent";
import { getMuiTableConfig } from "../../utils/MuiTableUtils/muiTableBuilder";
import { useContext, useState } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import { BasicListContext } from "../../contexts/BasicListContext";
import { ImportErrorColumns } from "../../utils/MuiTableUtils/ColumnBuilders/ImportErrorColumns";
import { ImportErrorDetails } from "./ImportErrorDetails";
import BasicModal from "../helpers/BasicModal";
import { DeleteImportError } from "./DeleteImportError";
import { RequestHelper } from "../../utils/requestHelper";
import { SLASH } from "../../utils/strings";
import { createConfirmToast, createToast } from "../../utils/toast";
import Loader from "../utils/Loader";
import FileUpload from "../helpers/FileUpload";

export const ImportError = () => {
  const rq = new RequestHelper();
  const [showDetailErros, setShowDetailErros] = useState(false);
  const [importError, setImportError] = useState({});
  const [showConfirmDeleteImportError, setShowConfirmDeleteImportError] =
    useState(false);
  const [isUploadLoading, setIsUploadLoading] = useState(false);
  const { open } = useContext(GlobalContext);
  const {
    rowCount,
    data,
    isLoaded,
    isError,
    pagination,
    setPagination,
    columnFilters,
    setColumnFilters,
    globalFilter,
    setGlobalFilter,
    sorting,
    setSorting,
    isLoading,
    refresh,
    setRefresh,
  } = useContext(BasicListContext);

  const columns = ImportErrorColumns(
    setImportError,
    setShowDetailErros,
    setShowConfirmDeleteImportError,
  );

  // Get the table configuration
  const c = getMuiTableConfig(
    // Params
    { enableColumnFilters: true, enableExpanding: true },
    // States & setStates (from context) Have to be the same as this
    {
      rowCount,
      isLoaded,
      isError,
      pagination,
      setPagination,
      columnFilters,
      setColumnFilters,
      globalFilter,
      setGlobalFilter,
      sorting,
      setSorting,
      isLoading,
    },
  );

  const table = useMaterialReactTable({
    columns: columns,
    data: data,
    ...c,
    enableColumnResizing: true,
    enableColumnOrdering: true,
    enableGlobalFilter: false,
    enableColumnFilters: false,
    enableSorting: true,
    initialState: {
      density: "compact",
      sorting: [
        { id: "importDate", desc: true }, // Tri descendant par défaut
      ],
    },
  });

  const deleteFile = () => {
    createConfirmToast(
      _SWAL_ICONS.warning,
      "Are you sure you want to force delete all files? This action cannot be undone.",
      "",
      "Yes, delete",
      "Cancel",
    ).then((confirmed) => {
      console.log(confirmed);
      if (confirmed) {
        forceDeleteFiles();
      }
    });
  };

  const forceDeleteFiles = () => {
    // Delete files request
    setIsUploadLoading(true);
    rq.doRequest(_ACTIONS.GET, _ROUTES.FORCE_DELETE_FILES)
      .then((res) => {
        setIsUploadLoading(false);
        if (res.status === _HTTP.ok) {
          createToast(_SWAL_ICONS.success, res.data).then(() => {
            setRefresh(refresh + 1);
          });
        }
      })
      .catch(() => {
        setIsUploadLoading(false);
      });
  };

  const deleteImportError = (importError) => {
    setShowConfirmDeleteImportError(false);
    setIsUploadLoading(true);
    rq.doRequest(
      _ACTIONS.DELETE,
      _ROUTES.IMPORT_ERRORS + SLASH + importError.id,
    )
      .then((res) => {
        setIsUploadLoading(false);
        if (res.status === _HTTP.noContent) {
          createToast(
            _SWAL_ICONS.success,
            "Imported data successfully deleted",
          ).then(() => {
            setRefresh(refresh + 1);
          });
        }
      })
      .catch(() => {
        setIsUploadLoading(false);
      });
  };

  const forceImport = () => {
    setIsUploadLoading(true);
    rq.doRequest(_ACTIONS.GET, _ROUTES.FORCE_IMPORT)
      .then((res) => {
        setIsUploadLoading(false);
        if (res.status === _HTTP.ok) {
          createToast(_SWAL_ICONS.success, res.data).then(() => {
            setRefresh(refresh + 1);
          });
        }
      })
      .catch(() => {
        setIsUploadLoading(false);
      });
  };

  if (isUploadLoading) {
    return <Loader />;
  }

  return (
    <>
      <Box
        sx={{
          width: "100%",
          maxWidth: open ? window.innerWidth - 340 : window.innerWidth - 64,
          borderRadius: "1px",
          boxShadow: `0px 0px 2px ${_COLORS.grey} `,
          overflowX: "auto",
          backgroundColor: _COLORS.white,
        }}
      >
        {/* Table Component is here */}
        <MuiTableComponent route={_ROUTES.IMPORT_ERRORS} table={table} />
        <Grid2
          container
          spacing={2}
          sx={{ padding: 2, justifyContent: "space-between" }}
        >
          <Grid2 item>
            <Button
              variant="contained"
              sx={{ backgroundColor: _COLORS.warning }}
              onClick={() => forceImport()}
            >
              Force file import
            </Button>{" "}
            <Button
              variant="contained"
              sx={{ backgroundColor: _COLORS.lightDanger, marginLeft: 2 }}
              onClick={() => deleteFile()}
            >
              Force Delete files
            </Button>
          </Grid2>
          <Grid2 item>
            <FileUpload />
          </Grid2>
        </Grid2>
      </Box>
      {/* Modals */}
      <BasicModal
        showModal={showDetailErros}
        setShowModal={setShowDetailErros}
        title={"List of errors encoutered during import"}
        content={<ImportErrorDetails importError={importError} />}
        width={"800"}
      />
      <BasicModal
        showModal={showConfirmDeleteImportError}
        setShowModal={setShowConfirmDeleteImportError}
        title={"Confirm deleting importing data"}
        content={
          <DeleteImportError
            importError={importError}
            deleteImportError={deleteImportError}
          />
        }
        width={"800"}
      />
    </>
  );
};
